import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  PROJECTS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  CREATE_PROJECT: ({ commit, dispatch }, project) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects`, project).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_PROJECT: ({ commit, dispatch }, project) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/projects/${project.id}`, project).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROJECT: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/projects/${projectId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROJECTS_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/projects/info `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PROJECT: ({ commit, dispatch }, projectId) => {
    return new Promise((resolve, reject) => {
      Vue.http.delete(`${apiUrl}${version}/projects/${projectId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PROJECTS: ({ commit, dispatch }, projectIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/projects/delete`, { project_ids: projectIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/project/actions.js